module.exports = __webpack_public_path__ + "static/integrations-e911f45be1c6ca9ca82de9636ddfc16b.png";